export default __webpack_public_path__ + "static/media/stoyan_m.545f5f82.jpg";